import React from 'react'
import Book from '../../assets/book.svg'
import { t } from '@local/translations'

import styles from './NoMenus.module.css'

export const NoMenus = () => (
  <div className={styles.noMenus}>
    <Book className={styles.noMenuIcon} />
    <p className={styles.primary}>{t('no-menus.menu-not-available')}</p>
    <p className={styles.secondary}>{t('no-menus.items-cannot-be-added')}</p>
  </div>
)
